import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';

import {
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonContent,
} from '@ionic/angular/standalone';

import { XButtonComponent } from '../x-button/x-button.component';

@Component({
  selector: 'x-login-card',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    IonContent,
    IonCard,
    IonCardHeader,
    IonCardContent,
    XButtonComponent,
  ],
  templateUrl: './x-login-card.component.html',
  styleUrl: './x-login-card.component.scss',
})
export class XLoginCardComponent {
  actionLabel = input<string>('Sign in');
  loadingText = input<string>('Signing in…');
  loading = input<boolean>(false);
  error = input<string | null>(null);
  signIn = output<void>();
}
